import type { ReactNode } from 'react';

import { Button } from '@/components/Button/Button';
import { useAuth } from '@/hooks/useAuth';
import { useAppTranslation } from '@hooks/useAppTranslation';

export function LoginActionButton(): ReactNode {
  const { t } = useAppTranslation();
  const { login, isLoggingIn } = useAuth();

  const handleLogin = (): void => {
    void login();
  };

  return (
    <Button
      title={t('login.sso')}
      onPress={handleLogin}
      loading={isLoggingIn}
      accessibilityLabel={t('login.sso')}
    />
  );
}
